import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { aboutUs } from "../axios";
import { useLocation } from "react-router-dom";

const About = () => {
  const [aboutUsDetailes, setAboutUs] = useState({});

  useEffect(() => {
    const getAbout = async () => {
      const response = await aboutUs();
      if(response) {
        // console.log("data" , response);
        
        setAboutUs(response[0]);
      } 
    }

    getAbout();
  }, []);

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>درباره ما</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="about_section mt-60">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <figure>
                <div className="about_thumb">
                  <img src="assets/img/about/about1.jpg" alt="" />
                </div>
                <figcaption className="about_content">
                  <h1>درباره آتروپین</h1>
                  <p style={{ whiteSpace: "pre-line", textAlign: "right" }}>
                    {aboutUsDetailes.text}
                  </p>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default About;
